import React from 'react'
import "./AgentSideNavBar.scss"

function AgentSideNavBar({ navItems: navItems, onTabChange: onTabChange }) {
    const RenderNavItem = ({ Item }) => {
        return (
            <div className={`side-nav-item ${Item.active}`} onClick={e => onTabChange(Item)}>
                {Item.icon}
                {
                    Item.count ?
                        <span>{Item.count}</span> : null
                }
            </div>
        )
    }
    return (
        <>
            {navItems.map((item) => {
                return (
                    <RenderNavItem Item={item} />
                )
            })}
        </>
    )
}

export default AgentSideNavBar